import { render, staticRenderFns } from "./UserInfoChange.vue?vue&type=template&id=79f5a428&scoped=true"
import script from "./UserInfoChange.vue?vue&type=script&lang=js"
export * from "./UserInfoChange.vue?vue&type=script&lang=js"
import style0 from "./UserInfoChange.vue?vue&type=style&index=0&id=79f5a428&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5a428",
  null
  
)

export default component.exports